import DatePicker from "component/datePicker/datePicker"
import Checkbox from "component/checkbox/checkbox"
import { PeakDateRangeLocal } from "./hotelContractTypes"

interface PeakDateRangeProps {
    contractStartDate: string
    contractEndDate: string
    showValidationErrors?: boolean
    peakDateRanges: PeakDateRangeLocal[]
    onPeakDateRangesChange: (ranges: PeakDateRangeLocal[]) => void
    getPeakDateRangeErrors?: (rangeId: string, startDate: string, endDate: string) => string[]
}

const PeakDateRange = ({
    contractStartDate,
    contractEndDate,
    showValidationErrors = false,
    peakDateRanges,
    onPeakDateRangesChange,
    getPeakDateRangeErrors,
}: PeakDateRangeProps) => {

    const handleAddRange = () => {
        const newRange: PeakDateRangeLocal = {
            range_id: `peak_${Date.now()}_${Math.random()}`,
            start_date: "",
            end_date: "",
            flag_compulsory_meal: false,
            flag_different_surcharge: false,
        }
        onPeakDateRangesChange([...peakDateRanges, newRange])
    }

    const handleRemoveRange = (id: string) => {
        if (peakDateRanges.length > 1) {
            onPeakDateRangesChange(peakDateRanges.filter((range) => range.range_id !== id))
        }
    }

    const handleFieldChange = (id: string, field: keyof PeakDateRangeLocal, value: string | boolean) => {
        onPeakDateRangesChange(
            peakDateRanges.map((range) =>
                range.range_id === id ? { ...range, [field]: value } : range
            )
        )
    }

    return (
        <>
            
            <b>Peak date ranges</b>
            

            <div className="season-date-table-container">
                <table className="season-date-table peak-date-table">
                    <thead>
                        <tr>
                            {/* <th className="compulsory-meal-header">
                                <span>Compulsory</span>
                                <span>Meal</span>
                            </th> */}
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th className="different-surcharge-header">
                                <span>Different</span>
                                <span>Surcharge?</span>
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {peakDateRanges.map((range) => {
                            let startDateError: string | undefined = showValidationErrors && !range.start_date ? "Required" : undefined
                            let endDateError: string | undefined = showValidationErrors && !range.end_date ? "Required" : undefined

                            // Get detailed validation errors if validation function is provided
                            if (showValidationErrors && getPeakDateRangeErrors && range.start_date && range.end_date) {
                                const errors = getPeakDateRangeErrors(range.range_id, range.start_date, range.end_date)
                                if (errors.length > 0) {
                                    // Display the first error on the start date field
                                    startDateError = errors[0]
                                    endDateError   = errors[0]
                                }
                            }

                            return (
                                <tr key={range.range_id}>
                                    {/* <td className="compulsory-meal-cell">
                                        <Checkbox
                                            checked={range.flag_compulsory_meal}
                                            onChange={(checked) => handleFieldChange(range.range_id, "flag_compulsory_meal", checked)}
                                        />
                                    </td> */}
                                    <td>
                                        <DatePicker
                                            label=""
                                            placeholder="mm/dd/yyyy"
                                            value={range.start_date}
                                            minDate={contractStartDate || undefined}
                                            maxDate={contractEndDate || undefined}
                                            required={true}
                                            error={startDateError}
                                            onChange={(date) => handleFieldChange(range.range_id, "start_date", date)}
                                        />
                                    </td>
                                    <td>
                                        <DatePicker
                                            label=""
                                            placeholder="mm/dd/yyyy"
                                            value={range.end_date}
                                            minDate={range.start_date || contractStartDate || undefined}
                                            maxDate={contractEndDate || undefined}
                                            required={true}
                                            error={endDateError}
                                            onChange={(date) => handleFieldChange(range.range_id, "end_date", date)}
                                        />
                                    </td>
                                    <td className="different-surcharge-cell">
                                        <Checkbox
                                            checked={range.flag_different_surcharge}
                                            onChange={(checked) => handleFieldChange(range.range_id, "flag_different_surcharge", checked)}
                                        />
                                    </td>
                                    <td className="actions-cell">
                                        <button
                                            type="button"
                                            className="add-range-button"
                                            onClick={handleAddRange}
                                            title="Add peak date range"
                                        >
                                            +
                                        </button>
                                        {peakDateRanges.length > 1 && (
                                            <button
                                                type="button"
                                                className="remove-range-button"
                                                onClick={() => handleRemoveRange(range.range_id)}
                                                title="Remove peak date range"
                                            >
                                                ×
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default PeakDateRange
